import { AlertService } from 'src/app/common/alert.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppTokenHandler } from '../common/app-token-handler';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, finalize, retry, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ProgressService } from './progress.service';

@Injectable({ providedIn: 'root' })
export class WinAuthInterceptor implements HttpInterceptor {
    private pendingRequests : any=  0;
    private totalRequests : any=  0;
    
    constructor(private appToken: AppTokenHandler, private route: Router, private progressService: ProgressService, private alertService:AlertService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const access_token_value = this.appToken.getSessionToken();

        if (req.url.startsWith('https://login.microsoftonline.com')) {
            // If it is authentication server request then each sub sequent request Http Option withCredentials will be attached
            return next.handle(req);
          }
        else if (access_token_value != null) {

            const cloned_req = req.clone({
                headers: new HttpHeaders({
                    'access_token_value': this.appToken.getSessionToken(),
                    'AzureAccessToken': this.appToken.getAzureTokenFromLocalStorage(),
                }),
                withCredentials: true
                
            });
        
            return next.handle(cloned_req).pipe(retry(0),finalize(() => {
                this.totalRequests--;
                if(this.totalRequests<=0)
                {
                    this.progressService.ChangeProgressStatus(false);
                    this.totalRequests = 0;
                }
            }),catchError((error: HttpErrorResponse) => {
                 let errorMessage = '';
                 
                 if (error.error instanceof ErrorEvent) {
        
                   // client-side error
                    
                   errorMessage = error.error.message;
        
                 } else {
                    // if(!(window.location.href.includes('vendormodify') && window.location.href.includes('eccvendorrequest')))
                    // {
                        if (error.status === 404) {
                            this.route.navigate(['/pagenotfound']);
                        }
                        else if (error.status === 406) {
                            this.route.navigate(['/sessionexpired']);
                        }
                        else if (error.status === 408) {
                            this.route.navigate(['/sessionexpired']);
                        }
                        // else if (error.status <= 0) {
                        //     this.route.navigate(['/badrequest']);
                        // }
                        else if(error.status==440)
                        {
                            this.route.navigate(['/sessionexpired']);
                        }
                        else if(error.status==401)
                        {
                            this.route.navigate(['/unauthorize']);
                        }
                        // else if(error.status==400)
                        // {
                        //     this.route.navigate(['/badrequest'])
                        // }
                        else if(error.status==500)
                        {
                            this.route.navigate(['/internalservererror'])
                        }
                        // else {
                        //     this.alertService.notify('error', 'Server Error', 'Some error has occured - '+ error.error.message);
                        // }
                       // server-side error
                       else{
                           
                           errorMessage = error.error.Message;
                       }
                    // }                    
                 }
                 if(errorMessage!='')
                 {
                 }                 
                 //this.totalRequests = 0;
                 if (error.status != 406 && error.status!=408 && error.status!=440)
                 {
                    this.alertService.notify('error',error.statusText,errorMessage);
                 }
                return throwError(errorMessage);
               })
            );
        } else {
 
            //this.route.navigate(['/error/1']);
            //return of();
            return next.handle(req);
        }

        //this.totalRequests++;
        //this.progressService.ChangeProgressStatus(true);
        // return next.handle(req).pipe(
        //   finalize(() => {
        //     this.totalRequests--;
        //     if (this.totalRequests === 0) {
        //         this.progressService.ChangeProgressStatus(false);
        //     }
        //   })
        // );
    }
}